module.exports = __webpack_public_path__ + "img/buttons.82c169f8.svg";